import * as React from 'react';
import { useSelector } from 'react-redux';
import { DetectIsMobile } from 'utils/mobileDetect';
import {
  selectExpandedSidePanel,
  selectSidePanelOpen,
} from 'app/Layout/FrontendLayout/slice/selectors';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import { RowSection } from '../wrappers';

export interface FormRowProps {
  children: React.ReactNode;
  fullRow?: boolean;
  minRow?: boolean;
  hide?: boolean;
  wrapOnMobile?: boolean;
  isCover?: boolean;
  shrink?: '1' | '2' | '3';
}
export const FormRow = (props: FormRowProps) => {
  const { children, fullRow, hide, minRow, wrapOnMobile, isCover, shrink } =
    props;
  const isMobile = DetectIsMobile();
  const sidePanelExpanded = useSelector(selectExpandedSidePanel);
  const sidePanelOpen = useSelector(selectSidePanelOpen);
  const showShortView =
    isMobile || (sidePanelOpen && !sidePanelExpanded) || isCover;
  const shrinkClass = shrink ? `shrink-${shrink}` : '';
  const theme = useTheme();
  return (
    <RowSection
      theme={theme}
      className={clsx('row', shrinkClass, {
        shortView: showShortView,
        fullRow: fullRow,
        hideRow: hide,
        minRow: minRow && !showShortView && !fullRow,
        wrap: wrapOnMobile,
      })}
    >
      {children}
    </RowSection>
  );
};
